export enum AntGridFilterType {
	SearchBox = 'SearchBox',
	CheckBox = 'Checkbox',
}
